"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.NumberWrap = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    white-space: nowrap;\n    display: block;\n    text-align: right;\n    width: 100%;\n"], ["\n    white-space: nowrap;\n    display: block;\n    text-align: right;\n    width: 100%;\n"])));
exports.numberWrapId = 'grid-number-wrap';
exports.numberCellRenderer = function (_a) {
    var cellData = _a.cellData;
    return (react_1.default.createElement(exports.NumberWrap, { "data-selector-id": exports.numberWrapId }, String(cellData)));
};
var templateObject_1;
//# sourceMappingURL=numberCellRenderer.js.map